export const downloadData = (data, filename) => {
    let openAs = "download" // TODO: Static for now. Will become a config later
    switch (openAs) {
        case "download":
            let reader = new FileReader()
            reader.readAsDataURL(data)
            reader.onload = (e) => {
                let a = document.createElement('a')
                a.download = filename
                a.href = e.target.result
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            break
        case "new-tab":
            window.open(URL.createObjectURL(data), '_blank')
            break
    }
}

export const downloadBase64url = (url, filename) => {
    let openAs = "download" // TODO: Static for now. Will become a config later
    switch (openAs) {
        case "download":
            let a = document.createElement('a')
            a.download = filename
            a.href = url
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
            break
        case "new-tab":
            window.open(url, '_blank')
            break
    }
}

export const getDataURL = (contentType, contentBase64) => {
    return `data:${contentType};base64,${contentBase64}`
}
